import {inject, Injectable} from '@angular/core';
import {ThirdPartyLicenseOfferingDataService} from './third-party-license-offering-data.service';
import {Page} from '@uofu-uss/angular-util';
import {Observable} from 'rxjs';
import {User} from '@uofu-uss-aux/software-catalog-ng-core';

export type ThirdPartyLicenseType = 'STAFF' | 'STUDENT' | 'EMERITUS';

export interface ThirdPartyLicenseOffering {
  id: number;
  thirdPartyLicenseId: number;
  thirdPartyLicenseType: ThirdPartyLicenseType;
}

export function emptyThirdPartyLicenseOffering(): ThirdPartyLicenseOffering {
  return {
    id: 0,
    thirdPartyLicenseId: 0,
    thirdPartyLicenseType: 'STAFF'
  };
}

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyLicenseOfferingService {

  private readonly dataService = inject(ThirdPartyLicenseOfferingDataService);

  search(thirdPartyLicenseId: number, unid: string): Observable<Page<ThirdPartyLicenseOffering>> {
    return this.dataService.search(thirdPartyLicenseId, unid);
  }

  // TODO need to update allowed license type logic
  mapToAllowedOffering(offerings: ReadonlyArray<ThirdPartyLicenseOffering> = [],
                       user: User): ThirdPartyLicenseOffering | undefined {
    const studentOffering = offerings.find(o =>
      o.thirdPartyLicenseType === 'STUDENT');
    const emeritusOffering = offerings.find(o =>
      o.thirdPartyLicenseType === 'EMERITUS');
    const staffOffering = offerings.find(o =>
      o.thirdPartyLicenseType === 'STAFF');

    if (user.student && studentOffering) {
      return studentOffering;
    } else if (user.emeritus && emeritusOffering) {
      return emeritusOffering;
    } else if (staffOffering) {
      return staffOffering;
    } else {
      return undefined;
    }
  }
}
